import React, { useState } from "react";
import "./hostScreen.css";
import BottomBar from "../BottomBar";
import { ToastContainer } from "react-toastify";
import BackBtnSvg from "../../assets/ReactSvg/BackBtnSvg";
import PostIconSvg from "../../assets/ReactSvg/PostIconSvg";
import ChefDetailsIconSvg from "../../assets/ReactSvg/ChefDetailsIconSvg";
import classNames from "classnames";
import HostDetailsComponent from "./HostDetailsComponent";
import { useDispatch, useSelector } from "react-redux";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { menuActions } from "../../store/menuSlice";
import Experiences from "./Experiences";
import BackFilledSvgIcon from "../../assets/ReactSvg/BackFilledSvgIcon";

const HostScreen = () => {
  const dispatch = useDispatch();
  const [viewExperiencePage, setViewExperiencePage] = useState(false);
  const hostList = useSelector((state) => state.host.hostList);
  const currentChefIdClicked = useSelector(
    (state) => state.menu.currentChefIdClicked
  );
  const hostDetails = hostList.find((host) =>
    host.chefs.includes(currentChefIdClicked)
  );
  const {
    name,
    role = [],
    post = [],
    location,
    language,
    reply,
    availability,
    hostExperience = [],
  } = hostDetails || {};

  const onBackClick = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  const onChefClick = (chefId) => {
    dispatch(menuActions.setCurrentChefIdClicked(chefId));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  const onViewAllClick = () => {
    setViewExperiencePage(true);
  };

  const onHostClick = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  return (
    <>
      {!viewExperiencePage ? (
        <div className="chef-individual-screen-wrapper">
          <div className={`chef-individual-screen open`}>
            <div className="chefImageWrapper">
              <div className="hostDesignContainerWrapper">
                <div onClick={onHostClick} className="hostTopBackbtn">
                  <BackFilledSvgIcon size={20} />
                </div>
                <img
                  className="hostBannerImg"
                  src="https://i.ibb.co/7thqHtFy/Frame-1000022547.png"
                />
                <div className="chefBgShadow"></div>
                <div className="hostPageWrapper">
                  <div className="chefDetailsListInfo">
                    <div className="hostCardWrapper">
                      <img
                        className="hostCardImage"
                        src="https://i.ibb.co/V0qBYf1x/image.png"
                      />
                      <div>
                        <div className="hostNameLabel Satoshi">{name}</div>
                        <div className="hostNameDescLabelWrapper">
                          {role.map((r) => (
                            <div className="hostNameDescLabel Satoshi">{r}</div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="hostDescWrapper" style={{ marginTop: 16 }}>
                      <div
                        style={{ marginTop: 0 }}
                        className="hostNameDescLabelWrapper"
                      >
                        <div className="hostNameDescLabel Satoshi">
                          {location}
                        </div>
                        <div className="hostNameDescLabel Satoshi">
                          {language}
                        </div>
                      </div>
                      <div
                        style={{ marginTop: 0 }}
                        className="hostNameDescLabelWrapper"
                      >
                        <div className="hostNameDescLabel Satoshi">
                          {availability}
                        </div>
                        <div className="hostNameDescLabel Satoshi">{reply}</div>
                      </div>
                    </div>
                    <div></div>
                  </div>

                  <HostDetailsComponent
                    hostDetails={hostDetails}
                    onChefClick={onChefClick}
                    onViewAllClick={onViewAllClick}
                  />
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
          <BottomBar isExplore />
        </div>
      ) : (
        <Experiences
          hostExperience={hostExperience}
          setViewExperiencePage={setViewExperiencePage}
        />
      )}
    </>
  );
};

export default HostScreen;
